export interface CompanyNameId {
	displayName: string;
	name: string;
	id: string;
}

export const isCompanyId = (companyId: string): boolean => {
	return !!companyId && typeof companyId === "string" && companyId.match(/^\d{7}-?\d$/) !== null;
};

export const parseNameId = (displayName: string): CompanyNameId => {
	const ind = displayName.indexOf(" ");
	const businessId = displayName.substring(0, ind).replaceAll("-", "");
	const name = displayName.substring(ind + 1);

	return {
		displayName: displayName,
		name: name,
		id: businessId
	};
};

export const toDisplayName = (companyId: string, companyName: string): string => {
	return `${companyId} ${companyName}`;
};

export const companyIdEquals = (id1: string, id2: string): boolean => {
	return id1.replaceAll("-", "") === id2.replaceAll("-", "");
};
